import React from "react";

import ProjectShowcaseTabWindowPart from "./ProjectShowcaseTabWindowPart";

import "./RepositoryBody.scss";

const RepositoryBody = ()=> {
    return (
        <div>
            This is reporsitory body
        </div>
    );
}

export default RepositoryBody;